export default "<div class=\"icon\">\n    <div class=\"icon__container\" [style.color]=\"color\">\n        <ng-content></ng-content>\n    </div>\n</div>\n\n"